module.exports = __webpack_public_path__ + "static/contact-example-0a3079c823a3e702e729a9ef50ad7987.png";